
<div class="llm-chat-panel font-pretendard">
  <!-- header -->
  <div class="llm-chat-header d-flex align-center justify-space-between">
    <!-- 대화 목록 dropdown -->
    <v-menu
      v-model="conversationMenu"
      offset-y
      bottom
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on, value }">
        <div v-on="on"
          class="llm-chat-conversation-btn hover-bg-color d-flex align-center"
          style="--hover-bg-color: #F8F9FB"
        >
          <div class="llm-chat-conversation-title">
            {{ selectedConversationTitle }}
          </div>
          <v-icon :class="value ? 'up' : 'down'" style="font-size: 22px; color: #8A8DA8">
            mdi-chevron-down
          </v-icon>
        </div>
      </template>
      <v-card class="llm-chat-conversation-card">
        <div class="llm-chat-conversation-card-header d-flex align-center justify-space-between">
          <div>대화 목록</div>
          <div>{{ conversationList.length }}개</div>
        </div>
        <div class="llm-chat-conversation-list">
          <div
            v-for="conversation in conversationList"
            :key="conversation.id"
            class="llm-chat-conversation-item d-flex align-center"
            @click="selectConversation(conversation)"
          >
            <div class="llm-chat-conversation-item-text">
              <div class="llm-chat-conversation-item-title">
                {{ conversation.title }}
              </div>
              <div class="llm-chat-conversation-item-date">
                {{ conversation.date }}
              </div>
            </div>
            <button
              type="button"
              class="llm-chat-conversation-delete default-icon-btn align-center justify-center"
              @click.stop="deleteConversation(conversation)"
            >
              <v-icon style="font-size: 18px; color: #414458">mdi-trash-can-outline</v-icon>
            </button>
          </div>
        </div>
      </v-card>
    </v-menu>

    <div class="llm-chat-header-actions d-flex align-center">
      <!-- 새 대화 버튼 -->
      <div v-if="selectedConversation"
        @click="$emit('start-new-conversation')"
        class="llm-chat-header-icon-btn default-icon-btn d-flex align-center justify-center"
      >
        <v-icon style="font-size: 20px; color: #8A8DA8">
          mdi-plus
        </v-icon>
      </div>

      <!-- 취소 버튼 -->
      <div @click="$emit('close')"
        class="llm-chat-header-icon-btn default-icon-btn d-flex align-center justify-center"
      >
        <v-icon style="font-size: 20px; color: #8A8DA8">
          mdi-close
        </v-icon>
      </div>
    </div>
  </div>

  <!-- body -->
  <div ref="messageList" class="llm-chat-body">
    <!-- 무엇을 도와드릴까요? -->
    <div v-if="messages.length === 0" class="llm-chat-empty">
      <img src="/assets/llm_on.svg" class="llm-chat-empty-icon">
      <div class="llm-chat-empty-title">무엇을 도와드릴까요?</div>
      <div class="llm-chat-suggestion-list">
        <button
          v-for="suggestion in suggestionList"
          :key="suggestion"
          type="button"
          class="llm-chat-suggestion default-white-btn d-flex align-center"
          @click="clickSuggestion(suggestion)"
        >
          {{ suggestion }}
        </button>
      </div>
    </div>

    <!-- 대화 내역 -->
    <div v-else class="llm-chat-message-list">
      <div
        v-for="(message, messageIdx) in messages"
        :key="message.id || messageIdx"
        class="llm-chat-message-row"
        :class="`is-${message.role}`"
      >
        <div v-if="message.timeText" class="llm-chat-message-time">
          {{ message.timeText }}
        </div>
        <div class="llm-chat-message" :class="`is-${message.role}`">
          <div v-if="message.role === 'error'" class="llm-chat-error-title">응답을 불러오지 못했습니다.</div>
          <div class="llm-chat-message-content">{{ message.content }}</div>
        </div>
      </div>
      <div v-if="loading" class="llm-chat-message-row is-assistant">
        <div class="llm-chat-message is-assistant">
          <div class="llm-chat-loading">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 입력창 -->
  <div class="llm-chat-input-wrap">
    <textarea
      ref="textarea"
      v-model="inputMessage"
      class="llm-chat-textarea"
      placeholder="메시지를 입력하세요."
      :disabled="loading"
      @keydown.enter="handleEnter"
    ></textarea>
    <div class="llm-chat-input-actions d-flex align-center justify-end">
      <button
        type="button"
        class="llm-chat-send-btn d-flex align-center justify-center"
        :class="canSend ? 'default-theme-btn is-active' : 'disabled-theme-btn is-disabled'"
        :disabled="!canSend"
        @click="sendMessage"
      >
        <v-icon style="font-size: 18px; color: #FFFFFF">mdi-send</v-icon>
      </button>
    </div>
  </div>
</div>
